// extracted by mini-css-extract-plugin
var _1 = "SeriesRow-module__active--N8WHY";
var _2 = "SeriesRow-module__noLink--V6gnn";
var _3 = "SeriesRow-module__noPadding--hzjxv";
var _4 = "SeriesRow-module__number--eOP2G";
var _5 = "SeriesRow-module__row--VlVQx";
var _6 = "SeriesRow-module__title--TOLyi";
export { _1 as "active", _2 as "noLink", _3 as "noPadding", _4 as "number", _5 as "row", _6 as "title" }
